/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2023-08-24 15:40:56
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\smart\schedul\g.js
 */
import request from "@/utils/request";
export const queryPage = "/icps/system/sign/basics/exception/query_page";
/*根据异常id获取附件列表*/
export function attachment_list(params) {
  return request({
    url: "/icps/system/sign/basics/exception/attachment_list",
    method: "get",
    params,
  });
}
/*根据异常id获取填写的处理信息*/
export function handler_info(params) {
  return request({
    url: "/icps/system/sign/basics/exception/handler_info",
    method: "get",
    params,
  });
}
// /*根据工程id获取图算列表*/
// export function graphic_list(params) {
//   return request({
//     url: "/icps/system/sign/basics/graphic/graphic_list",
//     method: "get",
//     params,
//   });
// }
/*新增或修改*/
export function save_handler(data) {
  return request({
    url: "/icps/system/sign/basics/exception/save_handler",
    method: "post",
    data,
  });
}
// /*获取强度等级和性能要求等。。。*/
// export function getLists(data) {
//   return request({
//     url: "/icps/system/sign/basics/namingRule/getLists",
//     method: "post",
//     data,
//   });
// }
export function getBusinessDetail(params) {
  return request({
    url: "/icps/system/sign/basics/exception/getBusinessDetail",
    method: "get",
    params,
  });
}

